// extracted by mini-css-extract-plugin
export default {"container":"Region_container__FZjW9","image":"Region_image__JB7-E","pack":"Region_pack__+49ZT","square":"Region_square__1vyhN"};